import React from "react";
import { TextField } from "@mui/material";
import {
  LocalizationProvider,
  DatePicker as MUIDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const DatePicker = ({ name, label, value, onChange, minDate, maxDate, shouldDisableDate, defaultValue }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MUIDatePicker
        name={name}
        label={label}
        value={value}
        views={['year', 'month', 'day']}
        defaultValue={defaultValue}
        minDate={minDate}
        maxDate={maxDate}
        onChange={(newValue) => onChange(newValue)}
        renderInput={(params) => <TextField {...params} fullWidth />}
        slotProps={{ textField: { size: 'small' } }}
        shouldDisableDate={shouldDisableDate}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
